/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

export const isAuthenticatedUser = Component =>
  function Authenticate(props) {
    const isAuthenticated = useSelector(state => state.auth.data.isAuthenticated);
    const location = useLocation();
    const path = location.pathname;
    if (!isAuthenticated) return <Redirect to={`/login?redirect=${path}`} />;

    return <Component {...props} />;
  };

export const isUnauthenticatedUser = Component =>
  function Authenticate(props) {
    const isAuthenticated = useSelector(state => state.auth.data.isAuthenticated);

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    let redirect = searchParams.get('redirect');
    if (!redirect) {
      redirect = '/';
    }
    if (isAuthenticated) return <Redirect to={redirect} />;

    return <Component {...props} />;
  };
